import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import AbstractGrantModeratorDialog, { abstractMapStateToProps } from '../AbstractGrantModeratorDialog';
import { Trans } from 'react-i18next';
/**
 * Dialog to confirm a grant moderator action.
 */
class GrantModeratorDialog extends AbstractGrantModeratorDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement(Dialog, { ok: { translationKey: 'dialog.Authorization' }, onSubmit: this._onSubmit, titleKey: 'dialog.grantModeratorTitle' },
            React.createElement("div", null,
                React.createElement(Trans, { i18nKey: "dialog.grantModeratorDialog", values: { participantName: this.props.participantName } }))));
    }
}
export default translate(connect(abstractMapStateToProps)(GrantModeratorDialog));
